<div class="mystery-game">
  <!-- Header -->
  <div class="game-header">
    <span class="question-counter">
      <span class="current">{{ getQuestionNum() | arabicNumber:currLang }}</span>
      <span class="sep">/</span>
      <span class="total">{{ getTotalQuestions() | arabicNumber:currLang }}</span>
    </span>
    <span class="game-title">🎁 {{ currLang === 'ar' ? 'الصندوق الغامض' : 'Mystery Box' }}</span>
    <div class="header-actions">
      <app-game-sound-control></app-game-sound-control>
      <button class="header-action-btn help-btn" (click)="showInfo = true">
        <span class="help-icon">?</span>
      </button>
    </div>
  </div>
  <app-game-info-modal *ngIf="showInfo" [gameType]="'mystery_box'" (close)="showInfo = false"></app-game-info-modal>

  <!-- Box Pick Phase -->
  <div class="box-pick" *ngIf="internalPhase === 'pick'">
    <h3 class="pick-title">{{ currLang === 'ar' ? 'اختر صندوقاً!' : 'Pick a box!' }}</h3>
    <div class="boxes-grid">
      <div *ngFor="let box of state?.boxes; let i = index"
           class="mystery-box"
           [class.used]="box.isUsed"
           [class.revealed]="box.isRevealed"
           (click)="pickBox(i)">
        <div class="box-front" *ngIf="!box.isUsed">
        </div>
        <div class="box-back" *ngIf="box.isUsed"
             [class.bonus-used]="getModifierCategory(box.modifier) === 'bonus'"
             [class.bamboozle-used]="getModifierCategory(box.modifier) === 'bamboozle'">
          <span class="box-check" [innerHTML]="getModifierIcon(box.modifier)"></span>
        </div>
      </div>
    </div>
    <div class="boxes-legend">
      <span class="legend-item">
        <span class="legend-dot bonus-dot"></span>
        {{ currLang === 'ar' ? 'مكافأة' : 'Bonus' }}
      </span>
      <span class="legend-item">
        <span class="legend-dot bamboozle-dot"></span>
        {{ currLang === 'ar' ? 'مقلب' : 'Bamboozle' }}
      </span>
    </div>
  </div>

  <!-- Student Spotlight -->
  <app-student-spotlight
    *ngIf="internalPhase === 'student-show' && currentStudent"
    [student]="currentStudent"
    [currLang]="currLang"
    [label]="currLang === 'ar' ? 'يجيب على السؤال!' : 'Answers the question!'">
  </app-student-spotlight>

  <!-- Modifier Reveal -->
  <div class="modifier-reveal" *ngIf="internalPhase === 'reveal' && state?.currentModifier">
    <div class="reveal-card"
         [class.bonus-card]="getModifierCategory(state.currentModifier) === 'bonus'"
         [class.bamboozle-card]="getModifierCategory(state.currentModifier) === 'bamboozle'"
         [style.--mod-color]="getModifierColor(state.currentModifier)">
      <span class="category-badge"
            [class.bonus-badge]="getModifierCategory(state.currentModifier) === 'bonus'"
            [class.bamboozle-badge]="getModifierCategory(state.currentModifier) === 'bamboozle'">
        {{ getCategoryLabel() }}
      </span>
      <span class="reveal-icon" [innerHTML]="getModifierIcon(state.currentModifier)"></span>
      <span class="reveal-name">{{ getModifierName(state.currentModifier) }}</span>
      <span class="reveal-desc">{{ getModifierDescription(state.currentModifier) }}</span>
    </div>
  </div>

  <!-- Question -->
  <div class="question-area" *ngIf="internalPhase === 'question' && currentQuestion">
    <!-- Current student + timer row -->
    <div class="question-top-row">
      <div class="current-student-bar" *ngIf="currentStudent">
        <app-student-avatar [student]="currentStudent" [size]="44" [active]="true"></app-student-avatar>
        <span class="current-student-name">{{ getCurrentStudentName() }}</span>
      </div>

      <div class="active-modifier"
           *ngIf="state?.currentModifier"
           [class.bonus-active]="getModifierCategory(state.currentModifier) === 'bonus'"
           [class.bamboozle-active]="getModifierCategory(state.currentModifier) === 'bamboozle'"
           [style.border-color]="getModifierColor(state.currentModifier)">
        <span [innerHTML]="getModifierIcon(state.currentModifier)"></span>
        {{ getModifierName(state.currentModifier) }}
      </div>

      <app-quiz-timer [value]="timerValue"
        [max]="state?.currentModifier === BoxModifier.EXTRA_TIME ? 45 : state?.currentModifier === BoxModifier.HALF_TIME ? 15 : state?.currentModifier === BoxModifier.FREEZE ? 10 : 30"
        [currLang]="currLang">
      </app-quiz-timer>
    </div>

    <app-question-card
      [question]="currentQuestion"
      [selectedOption]="selectedOption"
      (optionSelected)="selectOption($event)">
    </app-question-card>

    <button class="submit-btn" [class.active]="selectedOption" [disabled]="!selectedOption" (click)="submitAnswer()">
      {{ currLang === 'ar' ? 'تأكيد' : 'Submit' }}
    </button>
  </div>

  <!-- Result -->
  <div class="box-result" *ngIf="internalPhase === 'result' && lastResult">
    <div class="result-flash" [class.correct]="lastResult.isCorrect" [class.incorrect]="!lastResult.isCorrect">
      <span class="result-icon">{{ lastResult.isCorrect ? '&#10004;' : '&#10008;' }}</span>
      <span class="result-text">{{ lastResult.isCorrect ? (currLang === 'ar' ? 'صحيح!' : 'Correct!') : (currLang === 'ar' ? 'خطأ' : 'Incorrect') }}</span>
      <span class="result-xp" *ngIf="lastResult.xpEarned > 0">+{{ lastResult.xpEarned | arabicNumber:currLang }} XP</span>
      <span class="result-xp negative" *ngIf="lastResult.xpEarned < 0">{{ lastResult.xpEarned | arabicNumber:currLang }} XP</span>
      <span class="result-xp zero" *ngIf="lastResult.xpEarned === 0">{{ 0 | arabicNumber:currLang }} XP</span>
    </div>
  </div>
</div>
